module.exports = __webpack_public_path__ + "img/default-avatar-2.b089b9a.png";